import React, { useEffect, useState } from 'react'
import { Box, Flex, Image, Heading } from 'theme-ui'
import TextContent from '../../General/TextContent'
import EventItem from './EventItem'
import cloudinaryString from '../../../helpers/cloudinaryString'
let axios = require('axios')
let jsonpAdapter = require('axios-jsonp')
import Conditional from '../../General/Conditional'
const Events = props => {
  // ==== Destructuring
  const {
    gonationID,
    businessData,
    // configData,
    locationIndex,
    variantName,
    options
  } = props
  const { containerStyles, recurringEventsOnly, specialEventsOnly } = options || {}

  // ==== State
  const [recurringEvents, setRecurringEvents] = useState({
    eventsData: null,
    isLoading: true,
    modalShowing: ''
  })

  const [singleEvents, setSingleEvents] = useState({
    eventsData: null,
    isLoading: true,
    modalShowing: ''
  })

  // ==== Data Manipulation

  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  // ==== MOUNTING

  useEffect(() => {
    // fetch recurring events
    axios({
      url: `https://data.prod.gonation.com/profile/recurringevents?profile_id=${gonationID}`,
      adapter: jsonpAdapter
    })
      .then(res => {
        setRecurringEvents({
          ...recurringEvents,
          eventsData: res.data,
          isLoading: false
        })
      })
      .catch(e => {
        console.log('error : ', console.e)
        setRecurringEvents({ ...recurringEvents, isLoading: false })
      })

    // fetch special events
    axios({
      url: `https://data.prod.gonation.com/profile/events?profile_id=${gonationID}`,
      adapter: jsonpAdapter
    })
      .then(res => {
        setSingleEvents({
          ...singleEvents,
          eventsData: res.data,
          isLoading: false
        })
      })
      .catch(e => {
        console.log('error : ', console.e)
        setSingleEvents({ ...recurringEvents, isLoading: false })
      })
  }, [])

  const closeModal = () => {
    // maybe refactor at some point to recieve a type and then close the right one instead of close all
    setSingleEvents({ ...singleEvents, modalShowing: '' })
    setRecurringEvents({ ...recurringEvents, modalShowing: '' })
  }

  return (
    <Box sx={styles}>
      {!recurringEvents?.isLoading &&
      recurringEvents?.eventsData &&
      !specialEventsOnly &&
      recurringEvents?.eventsData?.events?.length ? (
        // ========== Start RECURRINGS EVENTS JSX ==============
        <Box variant={`${variantName}.container`} className="eventsOuterContainer container">
          <Flex variant={`${variantName}.eventsContainer`} className="eventsContainer recurringEventsContainer">
            <Conditional
              condition={
                !recurringEvents.isLoading &&
                recurringEvents.eventsData &&
                !specialEventsOnly &&
                recurringEvents?.eventsData?.events?.length
              }
            >
              {recurringEvents?.eventsData?.events.map(event => {
                return (
                  <EventItem
                    key={event._id}
                    event={event}
                    setEvents={setRecurringEvents}
                    closeModal={closeModal}
                    state={recurringEvents}
                    slug={businessData.slug}
                    variantName={variantName}
                  />
                )
              })}
            </Conditional>

            <Conditional
              condition={
                !singleEvents?.isLoading &&
                singleEvents?.eventsData &&
                !recurringEventsOnly &&
                singleEvents?.eventsData?.events?.length
              }
            >
              {singleEvents?.eventsData?.events.map(event => {
                return (
                  <EventItem
                    key={event._id}
                    event={event}
                    setEvents={setSingleEvents}
                    closeModal={closeModal}
                    state={singleEvents}
                    slug={businessData.slug}
                    variantName={variantName}
                  />
                )
              })}
            </Conditional>
          </Flex>
        </Box>
      ) : (
        ''
      )}

      {(!recurringEvents?.eventsData?.events?.length && !singleEvents?.eventsData?.events?.length) ||
      (!singleEvents?.eventsData?.events?.length && specialEventsOnly) ? (
        <Flex
          className="noEventsPosted"
          sx={{
            justifyContent: 'center',
            padding: '2rem 2rem 4rem',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Box className="logoContainer">
            <Image
              className="logo"
              sx={{ maxWidth: '250px', marginBottom: '2rem' }}
              src={cloudinaryString(businessData.avatar.imageBaseUrl, businessData.avatar.imagePrefix)}
            />
          </Box>
          <Heading className="noEventsPostedTitle" as="h4">
            No Events Posted,
          </Heading>

          <Heading className="noEventsPostedSubtitle" as="h5" sx={{ marginTop: '1rem', opacity: '0.7' }}>
            Please Check Back Again Later.
          </Heading>
        </Flex>
      ) : (
        ''
      )}
    </Box>
  )
}

export default Events
